import { Storage } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { createNewTicketAPI } from '@/service/ticketService';

export const handleCreateReplyEmailTicket = async (
    toEmailAddressList,
    ccEmailAddressList,
    bccEmailAddressList,
    replyDeliverStatus,
    formDetail,
    formData,
    replyDefaultData,
    fileReplyUploadList,
    corporationDetail,
    currentUserDetail,
    selectedProject,
    replyToEmailTicket
) => {

    let toList = processEmailAddressList(toEmailAddressList);
    let ccList = processEmailAddressList(ccEmailAddressList);
    let bccList = processEmailAddressList(bccEmailAddressList);

    if (Utils.isEmptyArray(toEmailAddressList) || Utils.isEmptyArray(toList)) {
        return;
    }

    let fields = {};
    if (!Utils.isEmptyArray(replyDefaultData)) {
        replyDefaultData.forEach(fieldDetail => {
            switch(fieldDetail?.sysField) {
                case Constant.SYS_FIELD.MAIL_SUBJECT:
                    fields[fieldDetail.id] = formData[fieldDetail.id]?.trim()
                    break; 
                case Constant.SYS_FIELD.MAIL_BODY: {
                    let bodyValue = Utils.removeDoubleQuotes(formData[fieldDetail.id]?.trim())
                    // Remove excess backslashes  
                    bodyValue = bodyValue.replace(/\\\\/g, '\\'); // Convert \\ to \
                    bodyValue = bodyValue.replace(/\\"/g, '"');   // Convert \" to "

                    fields[fieldDetail.id] = bodyValue
                    break; 
                }
                case Constant.SYS_FIELD.TO:
                    fields[fieldDetail.id] = toList;
                    break; 
                case Constant.SYS_FIELD.CC:
                    fields[fieldDetail.id] = ccList;
                    break; 
                case Constant.SYS_FIELD.BCC:
                    fields[fieldDetail.id] = bccList;
                    break;
                default:
                    return
        
            }
        })
    }

    let uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        () => {},
        fileReplyUploadList
    );

    let corpId = corporationDetail.id;
    let projectId = selectedProject.id;
    let fomrId = formDetail?.id;
    let parentId = replyToEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL ? replyToEmailTicket.id : replyToEmailTicket.parent; 

    let requestBody = {
        createTicketRequestDto: {
            corporationOrigin: corpId,
            projectOrigin: projectId,
            corporationTarget: corpId,
            ticketType: Constant.TICKET_TYPE.EMAIL_REPLY,
            affiliationOrganization: corpId,
            affiliationProject: projectId,
            projectTarget: [projectId],
            customer:projectId,
            fields: JSON.stringify(fields),
            type: fomrId,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            isDeliver: replyDeliverStatus,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            creator: currentUserDetail.id,
            createUserId: currentUserDetail.id,
            parentTicket: parentId
        },
    };

    // call API create ticket
    let newTicket = await createNewTicketAPI(null, requestBody);
    
    await Utils.delay(1000);

    return newTicket;
};

export const processEmailAddressList = (emailAddressList) => {
    let emailList = [];
    if (!Utils.isEmptyArray(emailAddressList)) {
        for (let emailElement of emailAddressList) {
            if (emailElement.projectId) {
                let userList = emailElement?.userList;
                if (userList.every(user => !user.selected)) {
                    continue
                };
                emailList.push(emailElement);
            } else {
                emailList.push(emailElement);
            }
        }
    }

    return emailList;
}

export const getOriginEmailSubjectValue = (emailTicketList, prefixSubject = '') => {
    if (Utils.isEmptyArray(emailTicketList)) return '';
    
    const ticketOrigin = emailTicketList[0];
    const listField = Utils.convertJSONDataToObject(ticketOrigin?.listField);
    let fieldSubject = listField.find(f => f.sysField === Constant.SYS_FIELD.MAIL_SUBJECT);
    fieldSubject = fieldSubject ? fieldSubject?.value : '';

    if (prefixSubject) {
        if (fieldSubject?.substring(0, prefixSubject.length) !== prefixSubject) {
            fieldSubject = prefixSubject + fieldSubject;
        }
    }

    return fieldSubject;
}

export const handleGetUploadFileList = async(fileUploadList, fileUpdatedList, fileDeletedList) => {
    if (Utils.isEmptyArray(fileUpdatedList)) return fileUploadList;

    let uploadedList = [...fileUpdatedList].filter(f => !fileDeletedList.find(deleted => deleted.fileUrl === f.fileUrl));
    if (!Utils.isEmptyArray(uploadedList)) {
        uploadedList = await Promise.all(uploadedList.map(
            async item => {
                const fileKey = item.fileUrl
                const S3Url = await Storage.get(fileKey);
                if (!S3Url) return null;
                const response = await fetch(S3Url);
                const blob = await response.blob();
                const originalName = fileKey.split('/').pop();

                const fileDetail = new File([blob], originalName, {
                    type: blob.type,
                    lastModified: new Date().getTime(),
                });
                return {
                    file: fileDetail,
                    isExpand: true,
                    isPdf: /\.(pdf|PDF)$/i.test(item?.fileName),
                    key: "",
                    progress: 0,
                    splitPdf: false,
                    status: true,
                }
            }
        ))
    }

    return [...fileUploadList, ...uploadedList]
}